type RandomUuidSource = {
  readonly randomUUID?: () => string;
  getRandomValues(values: Uint8Array): Uint8Array;
};

/** Uses the modern API when available and keeps API-31 WebView IDs ephemeral otherwise. */
export function randomUuid(
  source: RandomUuidSource = globalThis.crypto as unknown as RandomUuidSource,
): string {
  if (typeof source.randomUUID === 'function') return source.randomUUID();
  const bytes = source.getRandomValues(new Uint8Array(16));
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
  const hex = [...bytes].map((value) => value.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
